/**
 * APIからデータを取得する
 */
'use strict';
import store from '../store';
import { apiUrl, dbglog } from '../common/utils';

export function CallApi(name, param, callback) {
  if (param.length) {
    return callGetApi(apiUrl(name) + param, callback);
  }
  else {
    return callPostApi(apiUrl(name), param, callback);
  }
}

/**
 * GETメソッドによりAPIを呼び出す
 * @param {String} url 呼び出すAPIのURL
 * @param {function} callback 読み込みが完了した時に呼ばれるコールバック関数
 * @returns 中断用のコントローラを返す
 */
export function callGetApi (url, callback) {
  const authText = 'Bearer ' + store.state.token;
  const controller = new AbortController();

  fetch(url, {
    method: 'GET',
    mode: 'cors',
    headers: {
      Authorization: authText,
      /*
      userid: store.state.userInfo.userId,
      userName: store.state.userInfo.userName,
      clientIp: store.state.clientInfo.clientIp,
      */
    },
    signal: controller.signal,
  })
  .then((response) => {
    if (response.ok) {
      return response.json();
    }
    else if (response.status == 400) {
      return response.json().then(err => {
        return {
          errorCode: 400,
          message: err.message,
        };
      });
    }
    else {
      return {
        errorCode: response.status,
        errorDesc: response.statusText,
      }
    }
  })
  .then((data) => {
    callback(data);
  })
  .catch((err) => {
    dbglog(`callGetApi(${url}) error: ${err}`, -1);
    callback({ errorCode: 999, errorDesc: err });
  });

  return controller;
}

/**
 * POSTメソッドによりAPIを呼び出す
 * @param {String} url 呼び出すAPIのURL
 * @param {Object} paramObj APIに渡すパラメータ
 * @param {function} callback 読み込みが完了した時に呼ばれるコールバック関数
 * @returns 中断用のコントローラを返す
 */
export function callPostApi (url, paramObj, callback) {
  const authText = 'Bearer ' + store.state.token;
  const param = JSON.stringify(paramObj);
  const controller = new AbortController();

  fetch(url, {
    method: 'POST',
    mode: 'cors',
    cache: 'no-cache',
    headers: {
      Authorization: authText,
      'Content-Type': 'application/json'
    },
    body: param,
    signal: controller.signal,
  })
  .then((response) => {
    if (response.ok) {
      return response.json();
    }
    else if (response.status == 400) {
      return response.json().then(err => {
        return {
          errorCode: 400,
          message: err.message,
        };
      });
    }
    else {
      return {
        errorCode: response.status,
        errorDesc: response.statusText,
      };
    }
  })
  .then((data) => {
    callback(data);
  })
  .catch((err) => {
    console.log(`callPostApi(${url}, ${param}) error: ${err}`);
    callback({ errorCode: 999, errorDesc: err });
  });

  return controller;
}

/**
 * 記載証明書
 * @param {String} daichoId 概要書台帳ID
 * @param {function} callback 読み込みが完了した時に呼ばれるコールバック関数
 * @returns 中断用のコントローラを返す
 */
export function loadKisai (daichoId, callback) {
  const url = apiUrl('KisaiShomei') + '/' + daichoId;
  return callGetApi(url, callback);
}
 
/**
 * 建築計画概要書の属性詳細検索
 * @param {Object} condition 検索条件を保持するオブジェクト
 * @param {function} callback 読み込みが完了した時に呼ばれるコールバック関数
 * @returns 中断用のコントローラを返す
 */
export function searchAttr (condition, callback) {
  const url = apiUrl('AttrSearch');
  return callPostApi(url, condition, callback);
}

/**
 * 建築計画概要書の審査処分経過検索
 * @param {String} kojiId 工事ID
 * @param {function} callback 読み込みが完了した時に呼ばれるコールバック関数
 * @returns 中断用のコントローラを返す
 */
export function searchExam(kojiId, callback) {
  const url = apiUrl('ExamSearch') + '?kojiId=' + kojiId;
  return callGetApi(url, callback);
}
export function searchExamEx(kojiId, shubetsu, callback) {
  const url = apiUrl('ExamSearchEx') + '?kojiId=' + kojiId + '&type=' + shubetsu;
  return callGetApi(url, callback);
}

/**
 * 年度、区、番号に一致する概要データを非同期に検索する
 * @param {String} nendo 検索対象の年度文字列
 * @param {String} kuName 検索対象の区名称
 * @param {Number} bango 検索対象の受付番号（数値部分）
 * @param {function} callback 読み込みが完了した時に呼ばれるコールバック関数
 * @returns 中断用のコントローラを返す
 */
export function searchGaiyo (nendo, kuName, bango, callback) {
  let url = apiUrl('GaiyoSearch') + `?nendo=${nendo}&ku=${kuName}&bango=${bango}`;
  return callGetApi(url, callback);
}

/**
 * 住所検索
 * @param {Number} ward 区コード
 * @param {String} town 町名
 * @param {Number} oya 地番親番
 * @param {Number} eda 地番枝番
 * @param {function} callback 読み込みが完了した時に呼ばれるコールバック関数
 * @returns 中断用のコントローラを返す
 */
export function searchGaiyoByAddress (ward, town, oya, eda, callback) {
  const cond = `?ward=${ward}&town=${town}&oya=${oya==''?0:oya}&eda=${eda==''?0:eda}`
  let url = apiUrl('GaiyoSummary');
  switch (store.state.mode) {
    case 1:
      //url = apiUrl('GaiyoSummary');
      url = apiUrl('AddrSearch');
      break;
    case 2:
      url = apiUrl('elvSummary');
      break;
    case 3:
      url = apiUrl('TeihoSummary');
      break;
    case 7:
      url = apiUrl('KyoaiSummary');
      break;
    case 8:
      url = apiUrl('KousakuSummary');
      break;
  }
  url += cond;
  return callGetApi(url, callback);
}

/**
 * 指定したIDの位置指定道路データを非同期に取得する
 * @param {Number} id 位置指定道路の識別ID
 * @param {function} callback 読み込みが完了した時に呼ばれるコールバック関数
 * @returns 中断用のコントローラを返す
 */
export function loadShitei (id, callback) {
  const url = apiUrl('SpecRoad') + '/' + id;
  return callGetApi(url, callback);
}

/**
 * 位置指定道路データを受付番号により取得する
 * @param {String} ukeNo 受付番号
 * @param {function} callback 読み込みが完了した時に呼ばれるコールバック関数
 * @returns 中断用のコントローラを返す
 */
export function loadShiteiByUkeNo(ukeNo, callback) {
  const url = apiUrl('SpecRoad') + `?uke_no=${ukeNo}`
  return callGetApi(url, callback);
}
 
/**
 * 年度・番号に一致する位置指定道路を非同期に検索する
 * @param {Number} nendo 年度
 * @param {Number} bango 番号
 * @param {Number} eda   枝番
 * @param {function} callback 読み込みが完了した時に呼ばれるコールバック関数
 * @returns 中断用のコントローラを返す
 */
export function findShitei(nendo, bango, eda, callback) {
  const url = apiUrl('ShiteiSearch') + `?nendo=${nendo}&bango=${bango}&eda=${eda}`;
  return callGetApi(url, callback);
}
 
/**
 * 指定したIDの開発登録簿データを非同期に取得する
 * @param {Number} id 開発登録簿データの識別ID
 * @param {function} callback 読み込みが完了した時に呼ばれるコールバック関数
 * @returns 中断用のコントローラを返す
 */
export function loadKaihatsu (id, callback) {
  const url = apiUrl('Kaihatsu') + '/' + id;
  return callGetApi(url, callback);
}
 
/**
 * 開発登録簿データを受付番号で取得する
 * @param {String} ukeNo 受付番号
 * @param {function} callback 読み込みが完了した時に呼ばれるコールバック関数
 * @returns 中断用のコントローラを返す
 */
export function loadKaihatsuByUkeNo(ukeNo, callback) {
  const url = apiUrl('Kaihatsu') + `?uke_no=${ukeNo}`;
  return callGetApi(url, callback);
}

/**
 * 年度・区・番号に一致する開発登録簿を非同期に検索する
 * @param {String} gengo 元号
 * @param {Number} nendo 年度
 * @param {Number} ku 区コード
 * @param {Number} bango 番号
 * @param {function} callback 読み込みが完了した時に呼ばれるコールバック関数
 * @returns 中断用のコントローラを返す
 */
export function findKaihatsu(gengo, nendo, ku, bango, callback) {
  let url = apiUrl('KaihatsuSearch');
  if (gengo.length !== undefined && gengo.length > 0) {
    url += `?gengo=${gengo}&nendo=${nendo}&ku=${ku}&bango=${bango}`;
  }
  else {
    url += `?nendo=${nendo}&ku=${ku}&bango=${bango}`;
  }
  return callGetApi(url, callback);
}

/**
 * 宅造データを受付番号で取得する
 * @param {String} ukeNo 受付番号
 * @param {function} callback 読み込みが完了した時に呼ばれるコールバック関数
 * @returns 中断用のコントローラを返す
 */
export function loadTakuzoByUkeNo(ukeNo, callback) {
  const url = apiUrl('Takuzo') + `?uke_no=${ukeNo}`;
  return callGetApi(url, callback);
}
 
 /**
  * 指定したIDの宅造データを非同期に取得する
  * @param {Number} id 宅造データの識別ID
  * @param {function} callback 読み込みが完了した時に呼ばれるコールバック関数
  */
 export function loadTakuzo (id, callback) {
   const url = apiUrl('Takuzo') + '/' + id;
   return callGetApi(url, callback);
 }
 
 /**
  * 年度・区・番号に一致する宅造を非同期に検索する
  * @param {String} gengo 元号
  * @param {Number} nendo 年度
  * @param {Number} ku 区コード
  * @param {Number} bango 番号  
 * @param {Number} targetKaihatsuType 開発宅造の許可番号の種類 [開発, 旧宅造, 宅規, 農規, 森規, 土規] PlotMap.vueではnullを渡す
  * @param {function} callback 読み込みが完了した時に呼ばれるコールバック関数
  */
 export function findTakuzo(gengo, nendo, ku, bango, targetKaihatsuType, callback) {
   const url = apiUrl('TakuzoSearch') + `?gengo=${gengo}&nendo=${nendo}&ku=${ku}&bango=${bango}&targetKaihatsuType=${targetKaihatsuType}`;
   return callGetApi(url, callback);
 }
 
 /**
  * 指定したIDの狭あい道路データを非同期に取得する
  * @param {Number} id 狭あい道路データの識別ID
  * @param {function} callback 読み込みが完了した時に呼ばれるコールバック関数
  */
 export function loadKyoai (id, callback) {
   const url = apiUrl('Kyoai') + '/' + id;
   return callGetApi(url, callback);
 }
 
 export function findKyoaiByUkeNo(ukeNo, callback) {
   dbglog(`findKyoaiByUkeNo(${ukeNo})`);
   const url = apiUrl('Kyoai') + `?uke_no=${ukeNo}`;
   return callGetApi(url, callback);
 }
 
 /**
  * 年度・区・番号に一致する開発登録簿を非同期に検索する
  * @param {String} gengo 元号
  * @param {Number} nendo 年度
  * @param {Number} ku 区コード
  * @param {Number} bango 番号
  * @param {function} callback 読み込みが完了した時に呼ばれるコールバック関数
  */
 export function findKyoai(gengo, nendo, ku, bango, callback) {
   dbglog(`findKyoai(${gengo},${nendo},${ku},${bango})`);
   const url = apiUrl('KyoaiSearch') + `?gengo=${gengo}&nendo=${nendo}&ku=${ku}&bango=${bango}`;
   return callGetApi(url, callback);
 }
 
 /**
  * 指定したIDの建築確認プロット地図データを非同期に取得する
  * @param {Number} id 建築確認プロット地図データの識別ID
  * @param {function} callback 読み込みが完了した時に呼ばれるコールバック関数
  */
 export function loadKenkakuPlot(id, callback) {
   const url = apiUrl('KenkakuPlot') + `/${id}`;
   return callGetApi(url, callback);
 }
 
 /**
  * 指定したIDの建築確認プロット索引図データを非同期に取得する
  * @param {Number} id 建築確認プロット索引図データの識別ID
  * @param {function} callback 読み込みが完了した時に呼ばれるコールバック関数
  */
export function loadKenkakuPlotIndex(id, callback) {
  const url = apiUrl('KenkakuPlotIndex') + `/${id}`;
  return callGetApi(url, callback);
 }
 
 /**
  * 指定した区の建築確認プロット索引図リストを非同期に抽出する
  * @param {Number} kuCode 区コード
  * @param {function} callback 読み込みが完了した時に呼ばれるコールバック関数
  */
 export function extractKenkakuPlotIndices(kuCode, callback) {
   const url = apiUrl('KenkakuPlotIndex') + `?ward=${kuCode}`;
   return callGetApi(url, callback);
 }
 
 /**
  * 指定したIDの開発・造成・土石の堆積プロット地図データを非同期に取得する
  * @param {Number} id 開発・造成・土石の堆積プロット地図データの識別ID
  * @param {function} callback 読み込みが完了した時に呼ばれるコールバック関数
  */
 export function loadKaihatsuPlot(id, callback) {
   const url = apiUrl('KaihatsuPlot') + `/${id}`;
   return callGetApi(url, callback);
 }
 
 /**
  * 指定したIDの開発・造成・土石の堆積プロット索引図データを非同期に取得する
  * @param {Number} id 開発・造成・土石の堆積プロット索引図データの識別ID
  * @param {function} callback 読み込みが完了した時に呼ばれるコールバック関数
  */
 export function loadKaihatsuPlotIndex(id, callback) {
   const url = apiUrl('KaihatsuPlotIndex') + `/${id}`;
   return callGetApi(url, callback);
 }
 
 /**
  * 指定した区の開発・造成・土石の堆積プロット索引図リストを非同期に抽出する
  * @param {Number} kuCode 区コード
  * @param {function} callback 読み込みが完了した時に呼ばれるコールバック関数
  */
 export function extractKaihatsuPlotIndices(kuCode, callback) {
   const url = apiUrl('KaihatsuPlotIndex') + `?ward=${kuCode}`;
   return callGetApi(url, callback);
 }
 
  /**
  * 閲覧・印刷・ダウンロードなどのユーザーの行動ログを取得、ユーザー情報はstoreより取得
  * @param {Array} logDatas - 各ログの配列。各要素は[actionCode, actionName, ukeNo, kknnNo]の形式
  * @returns {Promise} 全ログ記録のAPIレスポンスを処理するPromise
  */
  export function registLog(logDatas) {
    return logDatas.reduce((promiseChain, [actionCode, actionName, ukeNo, kknnNo]) => {
      return promiseChain.then(async () => {
        const postLogData = {
          actionCode,
          actionName,
          clientIp: store.state.clientInfo.clientIp,
          userId: store.state.userInfo.id,
          userName: store.state.userInfo.userName,
          ukeNo,
          kknnNo,
        };
        return new Promise((resolve, reject) => {
          callPostApi(apiUrl('RegistLog'), postLogData, (response) => {
            if (response.errorCode) {
              console.error(`Error logging action ${actionCode}: ${response.errorDesc}`);
              reject(new Error(`Logging failed for action ${actionCode}`));
            } else {
              resolve(response);
            }
          });
        }).catch(error => {
          console.error(`ネットワークエラーまたはサーバーエラーでログ記録失敗 (${actionCode}):`, error);
        });
      });
    }, Promise.resolve());
  }
